// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__305ZE","select":"Header_select__-IHFD","clinic":"Header_clinic__1cmXY"};